var exports = {
  "h": "FlexSuiteSubNavSpacer__epz2pK",
  "E": "twoRows__cLVtUk",
};

module.exports = exports;
